import { string } from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Header } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router";
import CatalogPage from "../roomBook/CatalogPage";
import ConfiguratorsMenu from "./ConfiguratorsMenu";
import SectionMenu from "./SectionMenu";
import {
  getPageTitle,
  getUnit,
  getUnitPath,
  isReady
} from "../../selectors/unit";
import { getOnly3D } from "../../selectors/unit/unit";
import { getProductLine } from "../../selectors/unit/productLines";
import { ProductLineShape } from "../../shapes/productLine.shape";
import { UnitShape } from "../../shapes";
import ProductLinePicker from "../productLine/productLinePicker";

function Unit({ unit, unitPath, only3D, productLine }) {
  const title = unit.sample ? unit.description : unit.display_name;

  if (only3D) return <ConfiguratorsMenu only3D={only3D} />;
  return (
    <div data-component="unit">
      {productLine?.mode === "required" &&
      !(productLine?.selectedTags.length > 0) ? (
        <ProductLinePicker />
      ) : (
        <CatalogPage>
          <Header size="large" textAlign="right">
            {productLine?.name_plural && (
              <Button
                as={Link}
                to={`${unitPath}/productLine`}
                content={productLine.name_plural}
                icon="chevron left"
                basic
              />
            )}
          </Header>
          <ConfiguratorsMenu />

          <Header size="large">
            <FormattedMessage id="buyerPortal.menu.products" /> - {title}
          </Header>

          <SectionMenu unitPath={unitPath} />
        </CatalogPage>
      )}
    </div>
  );
}

Unit.propTypes = {
  unit: UnitShape.isRequired,
  unitPath: string.isRequired,
  only3D: string,
  productLine: ProductLineShape
};
Unit.defaultProps = {
  only3D: "",
  productLine: undefined
};

const mapStateToProps = (state, props) => {
  return {
    unit: getUnit(state),
    unitPath: getUnitPath(props),
    pageTitle: getPageTitle(state, props),
    isReady: isReady(state),
    only3D: getOnly3D(props),
    productLine: getProductLine(state, props)
  };
};

export default connect(mapStateToProps)(Unit);
